import { Disclosure, Menu, Transition } from "@headlessui/react"
import { FiX } from "react-icons/fi"
import { CgMenuRightAlt } from "react-icons/cg"
import { classNames } from "utils/classNames"
import NavItem from "./NavItem"
import { BiHomeAlt, BiPhone } from "react-icons/bi"
import { MdOutlineLanguage } from "react-icons/md"
import { t } from "i18next"

export default ({ transparent, handleNavItem }) => {
  const defaultLang = localStorage.getItem("lang")
  const menuItems = [
    { name: t("about"), href: "/about-us", icon: BiHomeAlt },
    // { name: "Янгиликлар", href: "/about-us", icon: HiOutlineNewspaper },
    { name: t("contact-us"), href: "/contact-us", icon: BiPhone },
    { name: t(defaultLang), button: "lang", icon: MdOutlineLanguage },
  ]
  return (
    <Disclosure as="nav" className={classNames(transparent ? "" : "")}>
      {({ open }) => (
        <>
          <div className="mx-auto max-w-7xl">
            <div className="relative flex items-center justify-between h-16">
              {/* <div className="absolute inset-y-0 left-0 items-center hidden">
                <Disclosure.Button
                  onClick={() => openMobileMenu(menuItems)}
                  className="inline-flex items-center justify-center rounded-md hover:bg-gray-700 hover:text-white focus:outline-none"
                >
                  <MobileMenuIcon className="block w-6 h-6" />
                </Disclosure.Button>
              </div> */}
              {/* <div className="flex items-stretch justify-start flex-1">
                <div className="flex items-center flex-shrink-0">
                  <Logo imgSrc={transparent ? LogoDark : LogoLight} />
                </div>
              </div> */}
              <div className="inset-y-0 right-0 flex items-center static sm:inset-auto">
                {/* <button
                  type="button"
                  className="w-full hover:text-white focus:outline-none"
                >
                  <FiBell className="w-5 h-5" aria-hidden="true" />
                </button> */}
                <Menu as="div" className="relative ml-3">
                  <div>
                    <Menu.Button className="flex text-sm text-black rounded-full focus:outline-none lg:hidden">
                      <span className="sr-only">Open user menu</span>
                      {open ? (
                        <FiX className="block w-6 h-6" aria-hidden="true" />
                      ) : (
                        <CgMenuRightAlt
                          className="block w-6 h-6 text-white"
                          aria-hidden="true"
                        />
                      )}
                    </Menu.Button>
                  </div>
                  <Transition
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 z-[1111] w-56 mt-6 rounded-md origin-top-right bg-white py-2 px-2 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      {menuItems.map((item, index) => (
                        <Menu.Item key={item.name}>
                          {({ close }) => (
                            <NavItem
                              item={item}
                              icon={item.icon}
                              handleNavItem={handleNavItem}
                              index={index}
                              close={close}
                            />
                          )}
                        </Menu.Item>
                      ))}
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
          </div>
        </>
      )}
    </Disclosure>
  )
}
